import React, { FunctionComponent, useState } from 'react';
import {
  FaRegCheckCircle, FaRegCircle, FaSms, FaEnvelope, FaBell
} from 'react-icons/fa';
import { IconContext } from 'react-icons';
import Sms from "@murphy-frontend/web-core/assets/icons/sms.svg";
import Notification from "@murphy-frontend/web-core/assets/icons/noti.svg";
import Email from "@murphy-frontend/web-core/assets/icons/email.svg";
import { CustomCheckbox } from '../../../common/components/MurphyCheckbox';


interface CommunicationTypeFilterProps {
  onCheckAllMobile: () => void;
  onCheckAllEmail: () => void;
  onCheckAllNotification: () => void;
  onCheckCriticalAlert: () => void;
  checkAllMobileChecked: boolean;
  checkAllEmailChecked: boolean;
  checkAllNotificationChecked: boolean;
  criticalAlertIsChecked: boolean;
  smsDisabled?: boolean;
  size?: 'small' | 'large';
  translations?: Record<string, string>;
  notificationDisabled?: boolean;
  emailDisabled?: boolean;
}

const styles = {
  buttonContainer: {
    borderWidh: 1,
    borderStyle: 'solid',
    borderColor: '#EBEBEB',
    width: '20rem',
    padding: 10,
    display: 'flex',
    marginBottom: 10,
    justifyContent: 'space-between',
    alignItems: 'center'
  }
}
const ChannelSelection: FunctionComponent<
  CommunicationTypeFilterProps
> = ({
  onCheckAllMobile,
  onCheckAllEmail,
  onCheckAllNotification,
  onCheckCriticalAlert,
  checkAllMobileChecked,
  checkAllEmailChecked,
  checkAllNotificationChecked,
  criticalAlertIsChecked,
  smsDisabled,
  size,
  translations,
  notificationDisabled,
  emailDisabled,

}) => {
    const buttonClass = size === "small" ?
      "recipients-select-button-small recipients-select-button-markall" :
      "recipients-select-button recipients-select-button-markall";
    const buttonClassUnSelected = size === "small" ?
      "recipients-select-button-small recipients-button-unselected" :
      "recipients-select-button recipients-button-unselected";

    const buttonContainerClass = size === "small" ?
      "recipient-item-button-container-small" :
      "recipient-item-button-container";

    const iconClass = size === "small" ?
      "recipient-item-icon-small" :
      "recipient-item-icon";

      const channels = [
        {
          key: 1,
          label: translations.sms || "SMS",
          icon: <Sms />,
          onPress: onCheckAllMobile,
          isHide: smsDisabled,
          isSelected: checkAllMobileChecked,
        },
        {
          key: 2,
          label: translations.notification || "Notification",
          icon: <Notification />,
          onPress: onCheckAllNotification,
          isHide: notificationDisabled,
          isSelected: checkAllNotificationChecked,
        },
        {
          key: 3,
          label: translations.email || "Email",
          icon: <Email />,
          onPress: onCheckAllEmail,
          isHide: emailDisabled,
          isSelected: checkAllEmailChecked,
        },
      ];

    return (
      <div style={{paddingLeft: 20, paddingRight: 20}}>
        <label style={{ fontSize: '18px', marginBottom: 20, color: 'grey', marginTop: 20, display: 'flex' }}>{translations.selectType || "Select alert channel(s)"}</label>
                  {channels.map(channel => {
                  if (channel.isHide) return null;

                  return (
                    <div key={channel.key} style={styles.buttonContainer}>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        {channel.icon}
                        <label style={{ marginLeft: 10 }}>{channel.label}</label>
                      </div>
                      <CustomCheckbox
                        onChange={() => channel.onPress()}
                        checked={channel.isSelected}
                        checkedColor="#00A098"
                        unCheckedColor="#7F7F7F"
                      />
                    </div>
                  );
                })}
                {checkAllNotificationChecked && (
                  <div className='flex-row-container vertical-aligner left-aligner margin-top-20'>
                    <CustomCheckbox onChange={(val) => {
                         onCheckCriticalAlert()
                        }} checked={criticalAlertIsChecked} checkedColor='#00A098' unCheckedColor='#7F7F7F' />
                        <div style={{display: 'flex', flexDirection: 'column', marginLeft: 10}}>
                          <label style={{color: 'grey'}}>{translations.criticalAlert || "Critical alert"}</label>
                          <label style={{color: 'grey', width: '30rem', fontSize: 14}}>{translations.crticalAlertDesc || "Critical Alert is a special push notification available for iOS devices which play a sound even if the device is on Mute or Do not Disturb."}</label>
                        </div>
                  </div>
                )}
      </div>
    );
  };

export default ChannelSelection;
